import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { parseCookies } from "nookies";
import LoadingShell from "components/LoadingShell/LoadingShell";
import { getServerSideAuth } from "../apiService/authService";
import { destroyCognitoCookies } from "helpers/index";

import { useApolloClient } from "@apollo/client/react";
import { getCurrentUser, signOut } from "aws-amplify/auth";

export default function Home({ isAuth }) {
  const router = useRouter();
  const cookies = parseCookies();
  const client = useApolloClient();

  useEffect(() => {
    let cancelled = false;

    // `isAuth` is the result of the SSR render of `/`. It CANNOT be used to
    // decide whether to redirect: after a fresh sign-in the page is still
    // holding the pre-login props (`isAuth: false`), and under the local
    // dev-bypass `getServerSideAuth` returns false for `/` by design. Guarding
    // on it left freshly-authenticated users parked here on LoadingShell.
    //
    // _app.js only renders this page once its own client-side Amplify session
    // check has passed, so reaching this effect already implies a session.
    // Verify it directly, with the same short retry _app.js uses for the v6
    // CookieStorage read race.
    const trySession = async (retries = 3, delayMs = 150) => {
      for (let attempt = 0; attempt <= retries; attempt++) {
        try {
          await getCurrentUser();
          return true;
        } catch (_) {
          if (attempt < retries) {
            await new Promise(r => setTimeout(r, delayMs));
          }
        }
      }
      return false;
    };

    trySession().then(authenticated => {
      if (cancelled) return;
      if (authenticated) {
        router.replace("/valuation/list");
        return;
      }
      console.error('[index] no Cognito session after retries — signing out');
      destroyCognitoCookies(cookies);
      signOut();
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return <LoadingShell />;
}
export const getServerSideProps = async context => {
  const isAuth = await getServerSideAuth(context);
  if (isAuth) {
    return {
      redirect: {
        destination: "/valuation/list",
        permanent: false
      }
    };
  }

  return {
    props: { isAuth }
  };
};
